import styles from './index.module.css'

import { LuExternalLink } from '@react-icons/all-files/lu/LuExternalLink'
import React from 'react'
import { Link } from 'react-router-dom'

import { TEAM_LIBRARY } from '@disco/constants/GroupTypes'
import { SEARCH_RESULTS_PANE } from '@disco/constants/PaneTypes'
import { TRACK_VIEW } from '@disco/constants/ViewTypes'
import { carryBrowseSearchToSearchPage } from '@disco/state-management/actions/search-handoff-actions'

import { Box, DiscoCallout } from 'components/ds'

import { useDispatch } from 'hooks/use-redux'

type BannerPane = {
  type?: string
  view?: string | null
  groupId?: number | null
  simSearch?: unknown
}

export const shouldShowViewInTableFormatBanner = (
  pane: BannerPane,
  groupType?: string,
): boolean => {
  if (pane.view !== TRACK_VIEW || pane.simSearch) return false

  const isBrowseTracks =
    groupType === TEAM_LIBRARY && typeof pane.groupId === 'number'
  const isGlobalSearchTracks =
    pane.type === SEARCH_RESULTS_PANE && typeof pane.groupId !== 'number'

  return isBrowseTracks || isGlobalSearchTracks
}

type Props = {
  useLegacySearch: boolean
  // Sort the Browse results were fetched with, carried over for prompt search.
  browseSort?: string[]
}

const ViewInTableFormatBanner = ({ useLegacySearch, browseSort }: Props) => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(carryBrowseSearchToSearchPage(useLegacySearch, browseSort))
  }

  return (
    <Box px="2" pt="2">
      <DiscoCallout type="feature" variant="soft" size="1">
        <Link
          to="/search"
          onClick={handleClick}
          className={styles.tableFormatLink}
        >
          View in table format
          <LuExternalLink aria-hidden="true" size={16} />
        </Link>
      </DiscoCallout>
    </Box>
  )
}

export default ViewInTableFormatBanner
